import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import store from "./store/store";
import axios from "axios"

import SeleccionPantallas from "./components/SeleccionPantallas.vue";
import MenuPantalla from "./components/Pantallas/MenuPantalla.vue";
import CompuertaPantalla from "./components/Pantallas/CompuertaPantalla.vue";
import GeneradorPantalla from "./components/Pantallas/GeneradorPantalla.vue";
import RegulacionPantalla from "./components/Pantallas/RegulacionPantalla.vue";
import AjustesNivelPantalla from "./components/Pantallas/AjustesNivelPantalla.vue";
import TemperaturasPantalla from "./components/Pantallas/TemperaturasPantalla.vue";
import ManualPantalla from "./components/Pantallas/ManualPantalla.vue";
import LimpiarrejasPantalla from "./components/Pantallas/LimpiarrejasPantalla.vue";
import AlarmasPantalla from "./components/Pantallas/AlarmasPantalla.vue";
import GeneradorMasDatosPantalla from "./components/Pantallas/GeneradorMasDatosPantalla.vue";
import DatosCuadroPantalla from "./components/Pantallas/DatosCuadroPantalla.vue";
import LoginComponent from "./components/Pantallas/LoginComponent.vue";

Vue.config.productionTip = false;
Vue.use(VueRouter);

// Rutas para el router /:numeroPantalla como parametro
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      component: SeleccionPantallas,
      name: "home",
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla",
      component: MenuPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/compuerta",
      component: CompuertaPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/generador",
      component: GeneradorPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/regulacion",
      component: RegulacionPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/ajustesnivel",
      component: AjustesNivelPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/temperaturas",
      component: TemperaturasPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/manual",
      component: ManualPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/limpiarrejas",
      component: LimpiarrejasPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/alarmas",
      component: AlarmasPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/generador/masdatos",
      component: GeneradorMasDatosPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/pantalla/:numeroPantalla/generador/datoscuadro",
      component: DatosCuadroPantalla,
      meta: { requireAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: LoginComponent,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // Verifica si la ruta requiere autenticación
  if (to.matched.some((record) => record.meta.requireAuth)) {
    const token = localStorage.getItem("token");

    // Verifica si NO hay un token en el localStorage
    if (!token) {
      // Si no hay token, redirige a la página de inicio de sesión.
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      // Si hay token, verifica su validez.
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_URL}:${process.env.VUE_APP_BACKEND_PORT}/api/auth/verify-token`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        // Si el token es válido, permite el acceso a la ruta.
        if (response.data.isValid) {
          next();
        } else {
          // Si no es válido, quitar el token y redirigir al login.
          localStorage.removeItem("token");
          next({ path: "/login" });
        }
      } catch (error) {
        // En caso de error (por ejemplo, el servidor no responde), eliminar el token y redirigir al login.
        console.error("Error al verificar el token:", error);
        localStorage.removeItem("token");
        next({ path: "/login" });
      }
    }
  } else { // Si no requiere auth
    next();
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
